import React from "react";
import { TrendingDown, Globe2, Fish, Waves } from "lucide-react";

const stats = [
  {
    icon: TrendingDown,
    value: "100M+",
    label: "Tiburones muertos cada año",
    description: "La pesca ilegal y el aleteo amenazan con extinguirlos en una sola generación.",
    accent: "text-rose-400",
    border: "hover:border-rose-400/40",
  },
  {
    icon: Fish,
    value: "37%",
    label: "Especies en peligro",
    description: "De las más de 500 especies de tiburones, una de cada tres está en riesgo crítico.",
    accent: "text-cyan-400",
    border: "hover:border-cyan-400/40",
  },
  {
    icon: Globe2,
    value: "50%",
    label: "Del oxígeno mundial",
    description: "Proviene del océano. Sin sus depredadores, todo el ecosistema colapsa.",
    accent: "text-emerald-400",
    border: "hover:border-emerald-400/40",
  },
  {
    icon: Waves,
    value: "400M",
    label: "Años de equilibrio",
    description: "Los tiburones llevan en los océanos desde antes que los dinosaurios. Podemos perderlos en décadas.",
    accent: "text-indigo-400",
    border: "hover:border-indigo-400/40",
  },
];

export default function Stats() {
  return (
    <section
      id="stats"
      data-testid="stats-section"
      className="relative py-24 sm:py-32 grain"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className="max-w-2xl mb-16">
          <span className="text-xs uppercase tracking-[0.2em] font-medium text-cyan-400">
            Por qué importa
          </span>
          <h2 className="font-heading text-4xl sm:text-5xl font-bold tracking-tight mt-4 mb-5">
            El paraíso se desangra.
            <br />
            <span className="text-slate-400">En silencio.</span>
          </h2>
          <p className="text-lg text-slate-300 leading-relaxed">
            Los números son devastadores. Y la mayoría sigue sin saberlo.
          </p>
        </div>

        <div
          data-testid="stats-grid"
          className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5"
        >
          {stats.map((s, i) => {
            const Icon = s.icon;
            return (
              <div
                key={i}
                data-testid={`stat-card-${i}`}
                className={`group relative bg-slate-900/40 border border-white/5 ${s.border} rounded-2xl p-7 transition-all duration-500 hover:-translate-y-1 backdrop-blur-sm`}
              >
                <Icon className={`w-7 h-7 ${s.accent} mb-6`} />
                <div className={`font-heading text-4xl sm:text-5xl font-bold ${s.accent} mb-2 tracking-tight`}>
                  {s.value}
                </div>
                <div className="text-white font-semibold mb-3 text-base">
                  {s.label}
                </div>
                <p className="text-sm text-slate-400 leading-relaxed">
                  {s.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
